import { round } from '../helpers'
import { isNumericDataType } from './abstractions';
import { computed } from '@vue/composition-api';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

export * from './abstractions';

export function getCellValue(item: any, data: any, dataName: string | null, dataIndex: string | number | null) {
    if (dataName != null) {
        let v = item[dataName];
        if (dataIndex != null) {
            return v && v[dataIndex] || null;
        }
        return v || null;
    }
    return data;
}

export function formatCellValue(item: any, value: any, index: number, dataType: string, dataPrecision: number,
                                locale?: any, fmt?: (item: any, i: number, value: any) => string)
{
    if (fmt != null && typeof fmt == 'function') {
        return fmt(item, index, value);
    }

    const tvalue = typeof value;

    if (isNumericDataType(dataType)) {
        // Make sure we can process the number as a real number of "null";
        // else just return the value without formatting.
        if (tvalue != 'number' && value != null) {
            return value.toString();
        }
        switch (dataType) {
            case 'integer':
                return (value || 0).toFixed(0);
            case 'number':
            case 'currency':
                return round(value || 0, locale?.number?.decimalSeparator, locale?.number?.thousandsSeparator, dataPrecision);
        }
    }
    else if (value == null) {
        // If value is null or undefined return the default value ('').
        return '';
    }
    else if (dataType.startsWith('date')) {
        let dateFormat = dataType.split(':')[1] || 'P';
        let date = tvalue == 'string' ? parseISO(value) : value;
        return format(date, dateFormat, { locale: locale?.date });
    }
    else {
        return value.toString();
    }
}

export function explodeRowProps(rowProps: { item: any, index: number, row: number, key: string } | undefined) {
    if (rowProps) {
        return {
            item: computed(() => rowProps.item.item),
            row: computed(() => rowProps.item.row),
            index: computed(() => rowProps.item.index)
        }
    }
    throw Error("Argument cannot be null: rowProps");
}
